import { gql } from '@apollo/client';

const getAllBookings = gql`
  query GetAllBookings($bookingFilter: BookingType!, $startDate: Date) {
    sessionBookingsForGuardian(bookingFilter: $bookingFilter, startDate: $startDate) {
      bookingId
      bookingType
      status
      date
      sessionType
      customSessionType {
        id
        name
        startTime
        endTime
      }
      showCustomSessionTimes
      child {
        id
        fullName
        guardian {
          fullName
          phoneNumber
          email
        }
      }
    }
  }
`;

export default getAllBookings;
